module.exports = __webpack_public_path__ + "static/media/img75.a3e01222.jpg";